<template>
  <div class="collection">
     <CollectionContent msg="CollectionContent template"/>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import CollectionContent from '@/components/CollectionContent.vue'

export default {
  name: 'collection',
  components: {
    Header,
    CollectionContent
  }
}
</script>